const cvc = { key: 'cvc', title: 'CVC' }
const cci = { key: 'cci', title: 'CCI' }
const cvo = { key: 'cvo', title: 'CVO' }
const picc = { key: 'picc', title: 'PICC' }
const midap = { key: 'midap', title: 'MIDline avec PI' }
const cart = { key: 'cart', title: 'Cathéters artériels' }
const caut = { key: 'caut', title: 'Autres cathéters centraux' }
const cdia = { key: 'cdia', title: 'Cathéters de dialyse' }
const fnat = { key: 'fnat', title: 'Fistule native' }
const fpro = { key: 'fpro', title: 'Fistule prothèse' }
const itb = { key: 'itb', title: 'Intubation / Trachéotomie' }
const fake = { key: 'fake', title: '', value: '' }

export default {
  getDenominators: function (a) {
    if (a == null) {
      return null
    }

    const result = []
    a.tables.forEach(
      t => {
        t.columns.forEach(
          c => {
            if (c.key !== fake.key) {
              result.push(c.key)
            }
          }
        )
      }
    )
    return result.sort((f, s) => f.localeCompare(s))
  },

  arrays: {
    base: [
      {
        name: 'Tableau Général',
        key: 'gen',
        tables: [
          { columns: [cvc, cci, cvo, picc, cart] },
          { columns: [caut, cdia, fnat, fpro, itb] }
        ]
      },

      {
        name: 'Tableau Réanimation',
        key: 'rea',
        tables: [
          { columns: [cvc, cci, picc, cart] },
          { columns: [caut, cdia, itb, fake] }
        ]
      },

      {
        name: 'Tableau Oncologie',
        key: 'onc',
        tables: [
          { columns: [cvc, cci, picc, fake] }
        ]
      },

      {
        name: 'Tableau Néonatalogie',
        key: 'neo',
        tables: [
          { columns: [cvc, cvo, fake, fake] }
        ]
      },

      {
        name: 'Tableau Dialyse',
        key: 'dia',
        tables: [
          { columns: [cdia, fnat, fpro, fake] }
        ]
      }
    ],

    '2025': [
      {
        name: 'Tableau Général',
        key: 'gen',
        tables: [
          { columns: [cvc, cci, cvo, picc, midap, cart] },
          { columns: [caut, cdia, fnat, fpro, itb, fake] }
        ]
      },

      {
        name: 'Tableau Réanimation',
        key: 'rea',
        tables: [
          { columns: [cvc, cci, picc, midap] },
          { columns: [cart, caut, cdia, itb] }
        ]
      },

      {
        name: 'Tableau Oncologie',
        key: 'onc',
        tables: [
          { columns: [cvc, cci, picc, midap] }
        ]
      },

      {
        name: 'Tableau Néonatalogie',
        key: 'neo',
        tables: [
          { columns: [cvc, cvo, fake, fake] }
        ]
      },

      {
        name: 'Tableau Dialyse',
        key: 'dia',
        tables: [
          { columns: [cdia, fnat, fpro, fake] }
        ]
      }
    ],

    '2026': [
      {
        name: 'Tableau Général',
        key: 'gen',
        tables: [
          { columns: [cvc, cci, cvo, picc, midap, cart] },
          { columns: [caut, cdia, fnat, fpro, itb, fake] }
        ]
      },

      {
        name: 'Tableau Réanimation',
        key: 'rea',
        tables: [
          { columns: [cvc, cci, picc, midap] },
          { columns: [cart, caut, cdia, itb] }
        ]
      },

      {
        name: 'Tableau Oncologie',
        key: 'onc',
        tables: [
          { columns: [cvc, cci, picc, midap] }
        ]
      },

      {
        name: 'Tableau Néonatalogie',
        key: 'neo',
        tables: [
          { columns: [cvc, cvo, picc, fake] }
        ]
      },

      {
        name: 'Tableau Dialyse',
        key: 'dia',
        tables: [
          { columns: [cdia, fnat, fpro, fake] }
        ]
      }
    ]
  }
}
